import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  title: 'Llevábamos 2 años con las mismas 6 comidas',
  text: 'A las 3 semanas de aplicar el método mi hijo tocó la zanahoria por primera vez. Lloré de emoción. Parece una pavada pero para nosotros fue un mundo. El tomo 1 me cambió la cabeza antes de cambiarle el plato a él.',
  name: 'Mamá de Valentina, 4 años',
  role: 'Buenos Aires'
}, {
  title: 'Lo de la tablet era un problema enorme en casa',
  text: 'Seguí el protocolo de 7 días y al día 5 ya comía sin pantalla. No lo podía creer. Lo más difícil fue el día 3. Pero el método te prepara exactamente para ese momento. Sabía qué esperar y qué hacer.',
  name: 'Papá de Isabella, 3 años',
  role: 'Rosario'
}, {
  title: 'Pensé que era otro producto genérico',
  text: 'Soy terapeuta ocupacional y lo recomiendo a todas las familias de mis pacientes. Está bien estructurado, es práctico y se nota que fue pensado para la realidad argentina. El banco de alimentos puente solo ya justifica el precio.',
  name: 'Terapeuta Ocupacional',
  role: 'Córdoba Capital'
}, {
  title: 'Lo mejor fue entender que no era culpa mía',
  text: 'Eso solo ya cambió todo en la mesa. Llegaba a la cena con tanta ansiedad acumulada que se la transmitía a mi hijo sin darme cuenta. El tomo 1 me lo explicó con tanta claridad que la primera noche ya fui diferente.',
  name: 'Mamá de Mateo (TEA), 6 años',
  role: 'Mendoza'
}, {
  title: 'En 2 meses pasamos de 5 alimentos a 9',
  text: 'Para nosotros eso es un mundo. El método es gradual, tiene lógica y sobre todo te dice exactamente qué hacer en cada momento. No hay que improvisar. Eso para una mamá agotada vale oro.',
  name: 'Mamá de Lucía, 5 años',
  role: 'Mar del Plata'
}];
export function TestimonialsSection() {
  return <section className="w-full py-20 md:py-24 px-4 bg-light-green" data-id="element-234">
      <div className="max-w-6xl mx-auto" data-id="element-235">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-heading" data-id="element-237">
            LO QUE DICEN LAS FAMILIAS QUE YA LO APLICARON
          </h2>
        </motion.div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-238">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="break-inside-avoid bg-white rounded-2xl p-6 md:p-8 shadow-md border border-primary-green/10 relative" data-id="element-239">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-primary-green/20" data-id="element-240" />

              <div className="flex mb-4" data-id="element-241">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-242" />)}
              </div>

              <h4 className="text-lg font-bold text-text-heading mb-3 italic" data-id="element-243">
                "{testimonial.title}"
              </h4>

              <p className="text-text-body mb-6 leading-relaxed" data-id="element-244">
                "{testimonial.text}"
              </p>

              <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-245">
                <p className="font-bold text-text-heading" data-id="element-246">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-500" data-id="element-247">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}